// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__-+52L","spinner":"loader_spinner__Dj-hn","spin":"loader_spin__sp9KT","loadingText":"loader_loadingText__i9pVE"};